import React, { useState, useEffect } from 'react'
import { Card, CardContent } from "../../ui/card"
import { Skeleton } from "../../ui/skeleton"
import { LibraryBig, Brain, Timer, History, ShieldCheck, KeyRound } from 'lucide-react'

export function Benefits() {
  const [isLoading, setIsLoading] = useState(true)
  
  const benefits = [
    { icon: LibraryBig, title: "Equipped with Complete Functional Expertise", description: "Knows all of Quantum Leap’s Sales, Marketing, Management, and Operations knowledge." },
    { icon: Brain, title: "No context needed", description: "Jump right in — AIRA understands your work" },
    { icon: Timer, title: "Instant replies", description: "Get answers instantly, no waiting around" },
    { icon: History, title: "Remembers your chat", description: "AIRA remembers the thread" },
    { icon: ShieldCheck, title: "Private & secure", description: "Enterprise-grade security with data encryption" },
    { icon: KeyRound, title: "Admin-controlled access", description: "Controlled rollout with proper access management" },
  ]

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section id="features" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-transparent to-purple-50/30 dark:from-slate-900/50 dark:via-transparent dark:to-slate-800/50"></div>
      <div className="container mx-auto max-w-[1200px] px-10  md:px-[72px] relative z-10">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold border">
            Why <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">AIRA</span>?
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Your intelligent assistant that understands your work context and delivers results faster than ever.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {isLoading ? (
            // Skeleton loading state
            Array.from({ length: 6 }).map((_, index) => (
              <Card key={index} className="group relative bg-background/70 backdrop-blur-xl border-border/50 overflow-hidden">
                <CardContent className="p-6 space-y-4 relative z-10">
                  <Skeleton className="w-12 h-12 rounded-xl" />
                  <Skeleton className="h-6 w-3/4" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-2/3" />
                </CardContent>
              </Card>
            ))
          ) : (
            benefits.map((benefit, index) => {
              const Icon = benefit.icon
              return (
                <Card key={index}   className="group relative bg-background/90 backdrop-blur-xl  border-[1px] border-[#0000000D] hover:scale-105 transition-all duration-200 shadow-xl -translate-y-1 overflow-hidden rounded-xl">
                  <div className="absolute inset-0 group-hover:bg-gradient-to-br from-blue-500/5 via-indigo-500/5 to-purple-500/5 opacity-100 transition-opacity duration-200 "></div>
                  <CardContent className="p-6 space-y-4 relative z-10">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 via-indigo-500/20 to-purple-500/20 flex items-center justify-center group-hover:from-blue-500/30 group-hover:via-indigo-500/30 group-hover:to-purple-500/30 transition-all duration-200">
                      <Icon className="h-6 w-6 text-indigo-600 dark:text-indigo-400 group-hover:scale-110 transition-transform duration-200" />
                    </div>
                    <h3 className="font-semibold text-lg text-indigo-600 dark:text-indigo-400 group-hover:text-indigo-700 dark:group-hover:text-indigo-300 transition-colors duration-200">
                      {benefit.title} 
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </CardContent>
                  <div className="absolute inset-0 ring-1 ring-indigo-500/20 rounded-xl transition-all duration-200"></div>
                </Card>
              )
            })
          )}
        </div>
      </div>
    </section>
  )
}


